export const swapEnter = (input: string): string => {
  // 使用正则匹配所有常见的换行符，并全局替换为分号
  return input.replace(/\r\n|\r|\n/g, '; ');
}
